import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/SmoothScroll";
import ScrollManager from "@/components/ScrollManager";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import QuoteWizard from "@/components/QuoteWizard";
import Home from "@/components/Home";
import ServicePage from "@/components/ServicePage";
import MethodePage from "@/components/MethodePage";
import ContactPage from "@/components/ContactPage";
import OverPage from "@/components/OverPage";
import BlogPage from "@/components/BlogPage";
import ArticlePage from "@/components/ArticlePage";
import AdminDashboard from "@/components/AdminDashboard";

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");

  return (
    <>
      <ScrollManager />
      <div className="App min-h-screen bg-background">
        {!isAdmin && <Navbar />}
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/softwash-methode" element={<MethodePage />} />
            <Route path="/gevelreiniging" element={<ServicePage />} />
            <Route path="/dakreiniging" element={<ServicePage />} />
            <Route path="/dakcoating" element={<ServicePage />} />
            <Route path="/dak-en-gevelimpregnering" element={<ServicePage />} />
            <Route path="/bedrijfspand-reinigen" element={<ServicePage />} />
            <Route path="/terras-reinigen" element={<ServicePage />} />
            <Route path="/over-softpro" element={<OverPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<ArticlePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </main>
        {!isAdmin && <Footer />}
        {!isAdmin && <QuoteWizard />}
        <Toaster position="top-center" richColors />
      </div>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll>
        <Shell />
      </SmoothScroll>
    </BrowserRouter>
  );
}

export default App;
